export default (url, params) => {
    const query = Object.keys(params)
        .map(k => {
            let str = encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
            if (Array.isArray(params[k])) {
                str = '';
                params[k].forEach(i => {
                    str = `${encodeURIComponent(k)}[]=${i}`;
                });
            }
            return str;
        })
        .join('&');

    return url + '?' + query;
};
